function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 7.99967,
  cy: 8.00004,
  r: 7.16667,
  fill: "#B70A0A",
  stroke: "#FFE9E9"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.2002 11.602C7.2002 11.1602 7.55837 10.802 8.0002 10.802C8.44202 10.802 8.8002 11.1602 8.8002 11.602C8.8002 12.0438 8.44202 12.402 8.0002 12.402C7.55837 12.402 7.2002 12.0438 7.2002 11.602Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.00013 3.33337C8.29468 3.33337 8.53346 3.57221 8.53346 3.86684V9.20149C8.53346 9.49611 8.29468 9.73495 8.00013 9.73495C7.70558 9.73495 7.4668 9.49611 7.4668 9.20149V3.86684C7.4668 3.57221 7.70558 3.33337 8.00013 3.33337Z",
  fill: "white"
});

const SvgAlertFill = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAlertFill, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/alert-fill.8c385b97.svg";
export { ForwardRef as ReactComponent };